if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cssLoaderHTML1=`<div class="windows8">
                    <div class="wBall" id="wBall_1">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_2">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_3">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_4">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_5">
                      <div class="wInnerBall"></div>
                    </div>
                  </div>`;
            cssLoaderHTML=`<div class='loading_text'><div class="windows8">
                    <div class="wBall" id="wBall_1">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_2">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_3">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_4">
                      <div class="wInnerBall"></div>
                    </div>
                    <div class="wBall" id="wBall_5">
                      <div class="wInnerBall"></div>
                    </div>
                  </div></div>`;

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      
      /*** Load images dynamic code start **/

     

      loadImage(url, callback) {
          const img = new Image();
          img.onload = () => callback(true, img);
          img.onerror = () => callback(false, null);
          img.src = url;
        }

        loadAllImage(url) {
          return new Promise((resolve) => {
            const img = new Image();

            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);

            img.src = url;
          });
        }
      
        loadVariantImagesFromFiles(current_variant)
        {
          
          const section_id = document.getElementById("section_id").value;
          const product_id = document.getElementById("product_id").value;
          
          
            let image_found = 0;
            const json = document.getElementById("variant-images-json");
            const variants = JSON.parse(json.textContent);
            //const variants = window.variantImagesData;
            

           
           
            

            var allow="1";
            if (!json){
                allow="";
            }

            const img_fix_height_width="&height=680&width=";

            if(allow=="1")
            {
                
                const container = document.getElementById("Slider-Gallery-main-"+section_id);

                const container_1 = document.getElementById("Slider-Gallery-main-1-"+section_id);
                
              
                document.getElementById('Slider-Gallery-main-1-' + section_id).classList.remove('desktop-grid-single');

                  variants.forEach(variant => {
                    
                    
                      if(variant.id==current_variant)
                      {
                          let found=false;
                          
                          container.innerHTML="";
                          container_1.innerHTML="";
                          container.innerHTML=this.cssLoaderHTML;
                          container_1.innerHTML=this.cssLoaderHTML;
                          
                          let total_images_load=0;
                          // Setting Image 1
                            this.loadImage(variant.image_1, (exists, img) => {
                              if (exists) {
                                image_found = 1;
                                
                                /** Load Mobile view image **/
                                let liTemplate = document.getElementById('Slide-template--demo');
                                let newLi = liTemplate.cloneNode(true);
                                newLi.id = 'Slide-Dynamic-1';
                                newLi.classList.add('custom-gallery-image-1');
                                
                                
                                newLi.removeAttribute('style');
                                let imageTag = newLi.querySelector('img');
                                if (imageTag) {
                                  imageTag.src = img.src;
                                  imageTag.alt = '';
                                  imageTag.setAttribute('data-src', img.src);
                                  imageTag.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                  container?.querySelector(".loading_text")?.remove();
                                  container_1?.querySelector(".loading_text")?.remove();
                                  
                                }
                                container.appendChild(newLi);
                                found = true;
                                total_images_load++;

                                /** Load Mobile view image **/
                                let liTemplate_1 = document.getElementById('Slide-template--demo-1');
                                let newLi_1 = liTemplate_1.cloneNode(true);
                                newLi_1.id = 'slider_img_1';
                                newLi_1.classList.add('custom-gallery-image-1');
                                newLi_1.removeAttribute('style');
                                let imageTag_1 = newLi_1.querySelector('img');
                                if (imageTag_1) {
                                  imageTag_1.src = img.src;
                                  imageTag_1.alt = '';
                                  imageTag_1.setAttribute('data-src', img.src);
                                  imageTag_1.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                }
                                container_1.appendChild(newLi_1);

                                createDots();
                                update();
                              }
                          });


                          // Setting Image 2
                            this.loadImage(variant.image_2, (exists, img) => {
                              if (exists) {
                                image_found = 1;
                                /** Load Mobile view image **/
                                let liTemplate = document.getElementById('Slide-template--demo');
                                let newLi = liTemplate.cloneNode(true);
                                newLi.id = 'Slide-Dynamic-2';
                                newLi.classList.add('custom-gallery-image-2');
                                newLi.removeAttribute('style');
                                let imageTag = newLi.querySelector('img');
                                if (imageTag) {
                                  imageTag.src = img.src;
                                  imageTag.alt = '';
                                  imageTag.setAttribute('data-src', img.src);
                                  imageTag.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                  container?.querySelector(".loading_text")?.remove();
                                  container_1?.querySelector(".loading_text")?.remove();
                                  
                                }
                                container.appendChild(newLi);
                                found = true;
                                total_images_load++;

                                /** Load Mobile view image **/
                                let liTemplate_1 = document.getElementById('Slide-template--demo-1');
                                let newLi_1 = liTemplate_1.cloneNode(true);
                                newLi_1.id = 'slider_img_2';
                                newLi_1.classList.add('custom-gallery-image-2');
                                newLi_1.removeAttribute('style');
                                let imageTag_1 = newLi_1.querySelector('img');
                                if (imageTag_1) {
                                  imageTag_1.src = img.src;
                                  imageTag_1.alt = '';
                                  imageTag_1.setAttribute('data-src', img.src);
                                  imageTag_1.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                }
                                container_1.appendChild(newLi_1);

                                createDots();
                                update();
                              }
                          });

                          // Setting Image 3
                            this.loadImage(variant.image_3, (exists, img) => {
                              if (exists) {
                                image_found = 1;
                                /** Load Mobile view image **/
                                let liTemplate = document.getElementById('Slide-template--demo');
                                let newLi = liTemplate.cloneNode(true);
                                newLi.id = 'Slide-Dynamic-3';
                                newLi.classList.add('custom-gallery-image-3');
                                newLi.removeAttribute('style');
                                let imageTag = newLi.querySelector('img');
                                if (imageTag) {
                                  imageTag.src = img.src;
                                  imageTag.alt = '';
                                  imageTag.setAttribute('data-src', img.src);
                                  imageTag.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                  container?.querySelector(".loading_text")?.remove();
                                  container_1?.querySelector(".loading_text")?.remove();
                                  
                                }
                                container.appendChild(newLi);
                                found = true;
                                total_images_load++;

                                /** Load Mobile view image **/
                                let liTemplate_1 = document.getElementById('Slide-template--demo-1');
                                let newLi_1 = liTemplate_1.cloneNode(true);
                                newLi_1.id = 'slider_img_3';
                                newLi_1.classList.add('custom-gallery-image-3');
                                newLi_1.removeAttribute('style');
                                let imageTag_1 = newLi_1.querySelector('img');
                                if (imageTag_1) {
                                  imageTag_1.src = img.src;
                                  imageTag_1.alt = '';
                                  imageTag_1.setAttribute('data-src', img.src);
                                  imageTag_1.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                }
                                container_1.appendChild(newLi_1);
                                createDots();
                                update();
                              }
                          });

                          // Setting Image 4
                            this.loadImage(variant.image_4, (exists, img) => {
                              if (exists) {
                                image_found = 1;
                                /** Load Mobile view image **/
                                let liTemplate = document.getElementById('Slide-template--demo');
                                let newLi = liTemplate.cloneNode(true);
                                newLi.id = 'Slide-Dynamic-4';
                                newLi.classList.add('custom-gallery-image-4');
                                newLi.removeAttribute('style');
                                let imageTag = newLi.querySelector('img');
                                if (imageTag) {
                                  imageTag.src = img.src;
                                  imageTag.alt = '';
                                  imageTag.setAttribute('data-src', img.src);
                                  imageTag.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                  container?.querySelector(".loading_text")?.remove();
                                  container_1?.querySelector(".loading_text")?.remove();
                                  
                                }
                                container.appendChild(newLi);
                                found = true;
                                total_images_load++;

                                /** Load Mobile view image **/
                                let liTemplate_1 = document.getElementById('Slide-template--demo-1');
                                let newLi_1 = liTemplate_1.cloneNode(true);
                                newLi_1.id = 'slider_img_4';
                                newLi_1.classList.add('custom-gallery-image-4');
                                newLi_1.removeAttribute('style');
                                let imageTag_1 = newLi_1.querySelector('img');
                                if (imageTag_1) {
                                  imageTag_1.src = img.src;
                                  imageTag_1.alt = '';
                                  imageTag_1.setAttribute('data-src', img.src);
                                  imageTag_1.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                }
                                container_1.appendChild(newLi_1);
                                createDots();
                                update();
                              }
                          });

                          if(total_images_load<=0){
                              
                              let default_img=variant.image_default
                                this.loadImage(default_img, (exists, img) => {
                                  let image_name="";
                                    if (exists) {
                                      image_name=img.src;
                                      
                                    }else{
                                      image_name=document.getElementById('product_image').value;
                                    }

                                    /** Load Mobile view image **/
                                      let liTemplate = document.getElementById('Slide-template--demo');
                                      let newLi = liTemplate.cloneNode(true);
                                      newLi.id = 'Slide-Dynamic-1';
                                      newLi.classList.add('custom-gallery-image-1');
                                      newLi.classList.add('custom-gallery-image-1-default');
                                      newLi.removeAttribute('style');
                                      let imageTag = newLi.querySelector('img');
                                      if (imageTag) {
                                        imageTag.src = image_name;
                                        imageTag.alt = '';
                                        imageTag.setAttribute('data-src', image_name);
                                        imageTag.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                        container?.querySelector(".loading_text")?.remove();
                                        container_1?.querySelector(".loading_text")?.remove();
                                        

                                      }
                                      container.appendChild(newLi);
                                      found = true;
                                      total_images_load++;

                                      /** Load Mobile view image **/
                                      let liTemplate_1 = document.getElementById('Slide-template--demo-1');
                                      let newLi_1 = liTemplate_1.cloneNode(true);
                                      newLi_1.id = 'slider_img_1';
                                      newLi_1.classList.add('custom-gallery-image-1');
                                      newLi_1.classList.add('custom-gallery-image-1-default');
                                      newLi_1.removeAttribute('style');
                                      let imageTag_1 = newLi_1.querySelector('img');
                                      if (imageTag_1) {
                                        imageTag_1.src = image_name;
                                        imageTag_1.alt = '';
                                        imageTag_1.setAttribute('data-src', image_name);
                                        imageTag_1.removeAttribute('loading'); // or set loading="lazy" if you prefer
                                      }
                                      container_1.appendChild(newLi_1);

                                });
                          }
                          //if no images loaded

                          container_1.style.display="none";
                          (async () => {
                            
                              const urls = [
                                variant.image_1,
                                variant.image_2,
                                variant.image_3,
                                variant.image_4
                              ];

                              // Wait for all image checks
                              const results = await Promise.all(urls.map(url => this.loadAllImage(url)));

                              // Count failed images
                              const failedCount = results.filter(r => !r).length;
                              
                              
                              if (failedCount === urls.length) {
                                // All images failed
                                //document.querySelector(".your-container").style.display = "none";
                                document.getElementById('Slider-Gallery-main-1-' + section_id).classList.add('desktop-grid-single');
                                container_1.style.display="grid";
                                
                              } else {
                                container_1.style.display="grid";
                                
                                // At least 1 valid image exists
                                //document.querySelector(".your-container").style.display = "block";
                                
                                
                              }

                              if(failedCount<=0)
                                {
                                  }
                                 
                                  document.querySelectorAll('.custom-gallery-image-1-default')
                                    .forEach(el => el.remove());
                                    

                                    setTimeout(function(){ 
                                      document.querySelectorAll('.custom-gallery-image-1-default')
                                    .forEach(el => el.remove());
                                     }, 2000);

                                
                            })();
                            

                      }// if current variation matches
                  });
                  if(image_found === 0)
                  {
                    container?.querySelector(".loading_text")?.remove();
                    container_1?.querySelector(".loading_text")?.remove();
                  }
            }// allow


        }


      applyHoverEffectTosortDesc()
      {
        var section_id=document.getElementById("section_id").value;
       // Top (Material) description logic
        const topDescription = document.getElementById("top-description-"+section_id);
        const materialItems = document.querySelectorAll(".Material-"+section_id+" .Material-item-"+section_id);
        let activeMaterial = null;

        let default_product_meta_short_description = document.getElementById("product_meta_short_description").innerHTML;
        // let default_product_meta_short_description_1 = document.getElementById("product_meta_short_description_1").innerHTML;
        const activeStoneDiv = document.querySelector('div.activate-stone');

        let default_product_meta_short_description_1 = activeStoneDiv?.dataset.description;
        

        let product_meta_short_description = '';
        let product_meta_short_description_1 = '';
        let active_stone_name = '';
        let active_material_name = '';

         // Bottom (Gemstone) description logic
        const bottomDescription = document.getElementById("bottom-description-"+section_id);

        materialItems.forEach(item => {
          
          const material_name = item.getAttribute("data-material-name");

          product_meta_short_description = default_product_meta_short_description.replace("{material_name}", material_name);
          product_meta_short_description_1 = default_product_meta_short_description_1.replace("{material_name}", material_name);
          if(item.classList.contains('activate'))
          {
            active_material_name = material_name;
          }
          // Hover: temporary preview
          item.addEventListener("mouseenter", () => {
            if (!activeMaterial || activeMaterial !== item)

              product_meta_short_description = default_product_meta_short_description.replace("{material_name}", material_name).replace("{gemstone_name}", active_stone_name);
              product_meta_short_description_1 = default_product_meta_short_description_1.replace("{material_name}", material_name).replace("{gemstone_name}", active_stone_name);
              topDescription.textContent = product_meta_short_description;
              bottomDescription.textContent = product_meta_short_description_1;
          });

          item.addEventListener("mouseleave", () => {
            if (activeMaterial)
            
            product_meta_short_description = default_product_meta_short_description.replace("{material_name}", material_name).replace("{gemstone_name}", active_stone_name);
            product_meta_short_description_1 = default_product_meta_short_description_1.replace("{material_name}", material_name).replace("{gemstone_name}", active_stone_name);
            topDescription.textContent = product_meta_short_description;
            bottomDescription.textContent = product_meta_short_description_1;
            
          });

          // Click: make active + lock text
          item.addEventListener("click", () => {
            materialItems.forEach(i => i.classList.remove("active-"+section_id));
            item.classList.add("active-"+section_id);
            topDescription.textContent = product_meta_short_description;
            bottomDescription.textContent = product_meta_short_description_1;
            activeMaterial = item;
            active_material_name=material_name;
          });
        });

       
        const gemstoneItems = document.querySelectorAll(".Gemstone-list-"+section_id+" .Material-item-"+section_id);
        let activeGemstone = null;

        gemstoneItems.forEach(item => {
          
          const stone_name = item.getAttribute("data-stone-name");


          product_meta_short_description = product_meta_short_description.replace("{gemstone_name}", stone_name);
          product_meta_short_description_1 = product_meta_short_description_1.replace("{gemstone_name}", stone_name);
          if(item.classList.contains('activate'))
          {
            active_stone_name = stone_name;
          }

          // Hover: temporary preview
          item.addEventListener("mouseenter", () => {
            if (!activeGemstone || activeGemstone !== item)
              product_meta_short_description = default_product_meta_short_description.replace("{material_name}", active_material_name).replace("{gemstone_name}", stone_name);
              product_meta_short_description_1 = default_product_meta_short_description_1.replace("{material_name}", active_material_name).replace("{gemstone_name}", stone_name);
              topDescription.textContent = product_meta_short_description;
              bottomDescription.textContent = product_meta_short_description_1;
          });

          item.addEventListener("mouseleave", () => {
            if (activeGemstone)
              
              product_meta_short_description = default_product_meta_short_description.replace("{material_name}", active_material_name).replace("{gemstone_name}", stone_name);
              product_meta_short_description_1 = default_product_meta_short_description_1.replace("{material_name}", active_material_name).replace("{gemstone_name}", stone_name);
              topDescription.textContent = product_meta_short_description;
              bottomDescription.textContent = product_meta_short_description_1;
          });

          // Click: make active + lock text
          item.addEventListener("click", () => {
            gemstoneItems.forEach(i => i.classList.remove("active-"+section_id));
            item.classList.add("active-"+section_id);
            bottomDescription.textContent = product_meta_short_description_1;
            activeGemstone = item;
            active_stone_name = stone_name;
          });

          item.addEventListener("mouseenter", () => {
            
            bottomDescription.textContent = product_meta_short_description_1;
          });

        });


        const activeDiv = document.querySelector('.activate-gold-material');
        const activeDiv1 = document.querySelector('.activate-stone');

        if (activeDiv) {
          const mouseOver = new Event('mouseenter', { bubbles: true });
          activeDiv.dispatchEvent(mouseOver);
          activeDiv.classList.add('hover');
        }

        if (activeDiv1) {
          const mouseOver = new Event('mouseenter', { bubbles: true });
          activeDiv1.dispatchEvent(mouseOver);
          activeDiv1.classList.add('hover');
        }
      }//// applyHoverEffectTosortDesc


        
      /*** Load images dynamic code end **/



      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;


        let section_id = document.getElementById("section_id").value;
        let container = document.getElementById("Slider-Gallery-main-"+section_id);

        let container_1 = document.getElementById("Slider-Gallery-main-1-"+section_id);
        container.innerHTML=this.cssLoaderHTML;
        container_1.innerHTML=this.cssLoaderHTML;


        this.renderProductInfo({
          shouldFetchFullPage:shouldFetchFullPage,
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          
          this.loadVariantImagesFromFiles(variant?.id);
          this.applyHoverEffectTosortDesc();
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ shouldFetchFullPage =null,requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
       
        
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
            
            
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          
          this.updateURL(productUrl, variant?.id);
          
          this.loadVariantImagesFromFiles(variant?.id);
          this.applyHoverEffectTosortDesc();
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
